<div class="pageTitle">
    {{ "Select Bank" | translate }}
</div>

<form (ngSubmit)="onSubmit()" #f="ngForm" novalidate>
    <div [loading]="isLoading" class="loading-pContent">
        <div class="pContent">
            <div class="listedOption" [class.mb-5]="cancelRedirectUrl">
                <div class="item" *ngFor="let item of banks; let i = index">
                    <input type="radio" id="option-{{ item.swiftCode }}" name="bank" [(ngModel)]="selectedBank" [value]="item" required>
                    <label for="option-{{ item.swiftCode }}">
                        <span>{{ item.bankName | beautifulEnum | translate }}</span>
                        <img src="assets/img/banks/{{ item.swiftCode }}.png" alt="{{ item.bankName }}" class="item-logo {{ item.swiftCode | lowercase }}">
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="pButton">
        <ng-container *ngIf="cancelRedirectUrl">
            <button class="btn bg-white" (click)="backToMerchant()" [disabled]="f.invalid || isLoading">
                {{ 'Cancel' | translate }}
            </button>
        </ng-container>

        <button class="btn btn-primary" type="submit" [disabled]="f.invalid || isLoading">
            {{ 'Continue' | translate }}
        </button>
    </div>
</form>